import { ShieldCheck, Fingerprint, ScanSearch, FileBadge, GraduationCap, BadgeCheck } from "lucide-react";
import { ReadinessBadge, VerificationStatus } from "@/components/Badges";
import { LogoMark } from "@/components/Logo";
import { fmtDate, mediaUrl } from "@/lib/api";

const ICONS = { identity: Fingerprint, background_screening: ScanSearch, credentials: FileBadge, professional_license: BadgeCheck, training: GraduationCap };

export default function PassportCard({ name, role, photo, passportNumber, readiness }) {
  return (
    <div className="space-y-5" data-testid="passport-card">
      <div className="cz-passport text-white rounded-3xl p-6 sm:p-8 relative overflow-hidden shadow-2xl border border-teal-500/20">
        <div className="absolute inset-0 cz-passport-lines" />
        <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-teal-400/10 blur-2xl" />
        <div className="relative flex flex-col sm:flex-row gap-6 sm:items-center justify-between">
          <div className="flex items-center gap-5">
            <div className="h-20 w-20 rounded-2xl bg-white/10 border border-white/20 overflow-hidden grid place-items-center">
              {photo ? <img src={mediaUrl(photo)} alt="" className="h-full w-full object-cover" /> : <span className="font-display text-2xl font-bold">{(name || "?").slice(0, 1)}</span>}
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.25em] text-teal-300 font-semibold flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5" /> Zunvel Passport™</div>
              <div className="font-display text-2xl font-bold mt-1" data-testid="passport-name">{name}</div>
              <div className="text-slate-300 text-sm">{role || "Role not set"}</div>
            </div>
          </div>
          <div className="flex flex-col items-start sm:items-end gap-3">
            <LogoMark size={40} />
            <div className="font-mono-cz text-sm tracking-widest text-teal-200" data-testid="passport-number">{passportNumber}</div>
          </div>
        </div>
        <div className="relative mt-6 flex flex-wrap items-center gap-3">
          <ReadinessBadge status={readiness?.status} />
          {readiness?.is_demo && <span className="text-[11px] font-bold uppercase tracking-wider text-amber-300">Demo record · statuses are not real verifications</span>}
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {readiness?.categories?.map((c) => {
          const I = ICONS[c.key] || ShieldCheck;
          return (
            <div key={c.key} className="cz-card p-4" data-testid={`passport-category-${c.key}`}>
              <div className="flex items-center justify-between">
                <span className="h-9 w-9 rounded-xl bg-teal-50 text-teal-700 grid place-items-center"><I className="h-4 w-4" /></span>
                {c.required && <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Required</span>}
              </div>
              <div className="font-semibold text-slate-900 mt-3 text-sm">{c.label}</div>
              <div className="mt-1"><VerificationStatus status={c.status} expiring={c.expiring} /></div>
              <div className="text-xs text-slate-500 mt-2 space-y-0.5">
                <div>Verified: {fmtDate(c.verified_at)}</div>
                <div>Expires: {c.expires_at ? fmtDate(c.expires_at) : "—"}</div>
              </div>
              {c.is_demo && c.status === "verified" && <div className="text-[10px] font-bold text-amber-700 mt-2">DEMO — not actually verified</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
